import { render, staticRenderFns } from "./LayoutGrid.vue?vue&type=template&id=1435fa96&scoped=true&lang=html&"
import script from "./LayoutGrid.vue?vue&type=script&lang=js&"
export * from "./LayoutGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435fa96",
  null
  
)

export default component.exports